export { default as useAxios } from './useAxios';
export { default as useLazyAxios } from './useLazyAxios';
